import { render, staticRenderFns } from "./letter-of-reference.component.vue?vue&type=template&id=32ab4f10"
import script from "./letter-of-reference.component.ts?vue&type=script&lang=ts&external"
export * from "./letter-of-reference.component.ts?vue&type=script&lang=ts&external"
import style0 from "./letter-of-reference.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports